<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { useVModel } from "@vueuse/core";
import { cn } from "@/lib/utils";

const props = defineProps<{
    defaultValue?: string | number;
    modelValue?: string | number;
    class?: HTMLAttributes["class"];
    suffix: string;
}>();

const emits = defineEmits<{
    (e: "update:modelValue", payload: string | number): void;
}>();

const modelValue = useVModel(props, "modelValue", emits, {
    passive: true,
    defaultValue: props.defaultValue,
});
</script>

<template>
    <div class="mt-2 flex rounded-md shadow-sm">
        <input
            id="company-website"
            v-model="modelValue"
            type="text"
            name="company-website"
            :class="
                cn(
                    'block w-full min-w-0 flex-1 rounded-none rounded-l-md border-0 py-1.5 text-stone-900 ring-1 ring-inset ring-stone-300 placeholder:text-stone-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6',
                    props.class ?? '',
                )
            "
            placeholder="zaptime"
        />
        <span
            class="inline-flex items-center rounded-r-md border border-l-0 border-stone-300 px-3 text-stone-500 sm:text-sm"
            >{{ suffix }}</span
        >
    </div>
</template>
